module.exports = __webpack_public_path__ + "img/bandrec-hh-logo.c093e6cb.svg";